<template>
    <div class="primary--text">
        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{ $t("tipo_fachada") | capitalize }}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Se proponen cinco tipos de fachadas, dos de hoja simple con aislamiento exterior y tres de doble hoja con aislamiento intermedio</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="fachadas"
                                          v-model="solucionConstructiva.tipoFachada"
                                          :cargando="cargandoFachadas"
                                          @change="cambiaFachada">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{ $t("hoja_interior") | capitalize }}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>En las fachadas de doble hoja, define el tipo de material que forma la hoja interior</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="hojasInterior"
                                          v-if="(solucionConstructiva.tipoFachada != null  && hojasInteriorCodigos.length > 0) || cargandoHojas"
                                          v-model="solucionConstructiva.hojaInterior"
                                          :cargando="cargandoHojas"
                                          @change="cambiaHojaInterior">
                </seleccion-componente-s-c>
                <div class="caption pa-2"
                     v-if="solucionConstructiva.tipoFachada == null && hojasInteriorCodigos.length > 0 && !cargandoHojas">
                    {{ $t("tipo_fachada_antes") | capitalize }}
                </div>
                <v-list
                    v-if="solucionConstructiva.tipoFachada != null && hojasInteriorCodigos.length <= 0 && !cargandoHojas">
                    <v-list-item class="secondary">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t("no_aplica") | capitalize }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{ $t("aislante") | capitalize }}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Elección del tipo de material que se desea incorporar a la solución constructiva como aislante térmico</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="aislantes"
                                          v-if="(solucionConstructiva.tipoFachada != null && (hojasInteriorCodigos.length <= 0 || solucionConstructiva.hojaInterior != null)) || cargandoAislantes"
                                          v-model="solucionConstructiva.aislante"
                                          :cargando="cargandoAislantes"
                                          @change="cambiaAislante">
                </seleccion-componente-s-c>
                <div class="caption pa-2"
                     v-if="solucionConstructiva.tipoFachada == null && solucionConstructiva.hojaInterior == null && !cargandoAislantes">
                    {{ $t("tipo_fachada_hoja_antes") | capitalize }}
                </div>
                <div class="caption pa-2"
                     v-if="solucionConstructiva.tipoFachada == null && solucionConstructiva.hojaInterior != null && !cargandoAislantes">
                    {{ $t("tipo_fachada_antes") | capitalize }}
                </div>
                <div class="caption pa-2"
                     v-if="solucionConstructiva.tipoFachada != null && (hojasInteriorCodigos.length > 0 && solucionConstructiva.hojaInterior == null) && !cargandoAislantes">
                    {{ $t("hoja_antes") | capitalize }}
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{ $t("barrera_vapor") | capitalize }}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Su función es la de evitar la aparición de posibles condensaciones intersticiales en las fachadas de doble hoja con aislamiento intermedio.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c propiedad="codigo" nombre="nombre" :items="barreraVapor"
                                          v-if="(solucionConstructiva.tipoFachada != null && solucionConstructiva.aislante != null && barreraVaporCodigos.length > 0) || cargandoBarreraVapor"
                                          v-model="solucionConstructiva.barreraVapor"
                                          :cargando="cargandoBarreraVapor"
                                          @change="cambiaBarreraVapor">
                </seleccion-componente-s-c>

                <v-list
                    v-if="solucionConstructiva.tipoFachada != null && solucionConstructiva.aislante != null && barreraVaporCodigos.length <= 0 && !cargandoBarreraVapor">
                    <v-list-item class="secondary">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t("no_aplica") | capitalize }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <div class="caption pa-2"
                     v-if="solucionConstructiva.tipoFachada == null && solucionConstructiva.aislante == null && !cargandoBarreraVapor">
                    {{ $t("tipo_fachada_aislante_antes") | capitalize }}
                </div>
                <div class="caption pa-2"
                     v-if="solucionConstructiva.tipoFachada == null && solucionConstructiva.aislante != null && !cargandoBarreraVapor">
                    {{ $t("tipo_fachada_antes") | capitalize }}
                </div>
                <div class="caption pa-2"
                     v-if="solucionConstructiva.tipoFachada != null && solucionConstructiva.aislante == null && !cargandoBarreraVapor">
                    {{ $t("aislante_antes") | capitalize }}
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import SeleccionComponenteSC from "../../Componentes/SeleccionComponenteSC";

    export default {
        name: "ComponentesFachadaR",
        components: {
            SeleccionComponenteSC
        },
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            solucionConstructiva: {type: Object, required: true},
            correcto: {type: Boolean, default: false},
        },
        data: function () {
            return {
                cargandoFachadas: false,
                fachadas: [],
                fachadasCodigos: [],
                cargandoHojas: false,
                hojasInterior: [],
                hojasInteriorCodigos: [],
                cargandoAislantes: false,
                aislantes: [],
                aislantesCodigos: [],
                cargandoBarreraVapor: false,
                barreraVapor: [],
                barreraVaporCodigos: [],
            }
        },
        mounted() {
            Promise.all([
                this.cargarTiposFachada(),
                this.cargarHojaInterior(),
                this.cargarAislantes(),
                this.cargarBarreraVapor()
            ])
                .then(() => {
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                });
        },
        watch: {
            solucionConstructiva: {
                handler() {
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                },
                deep: true
            }
        },
        methods: {
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            cargarTiposFachada() {
                let materialId = this.solucionConstructiva.materialDermis.id;
                let url = `fachada/obra-nueva/tipo-fachada/por-material/${materialId}`;
                this.fachadas = [];
                this.fachadasCodigos = [];

                return new Promise((resolve) => {
                    let anterior = this.solucionConstructiva.tipoFachada;

                    this.cargandoFachadas = true;
                    HttpHelper.get(url)
                        .then(data => {
                            this.fachadas = data;
                            data.forEach((type) => {
                                this.fachadasCodigos.push(type.codigo);
                            });
                            this.solucionConstructiva.tipoFachada = null;
                            if (anterior != null && this.fachadasCodigos.includes(anterior.codigo)) {
                                this.solucionConstructiva.tipoFachada = anterior;
                            }

                            resolve();
                        })
                        .finally(() => {
                            this.cargandoFachadas = false;
                        });
                });
            },
            cargarHojaInterior() {
                if (this.solucionConstructiva.tipoFachada == null) return;
                let fachada = this.solucionConstructiva.tipoFachada.codigo;
                let url = `fachada/obra-nueva/hoja-interior/por-tipo-fachada/${fachada}`;
                this.hojasInterior = [];
                this.hojasInteriorCodigos = [];

                return new Promise((resolve) => {
                    let anterior = this.solucionConstructiva.hojaInterior;

                    this.cargandoHojas = true;
                    HttpHelper.get(url)
                        .then(data => {
                            this.hojasInterior = data;

                            data.forEach((type) => {
                                this.hojasInteriorCodigos.push(type.codigo);
                            });
                            this.solucionConstructiva.hojaInterior = null;
                            if (anterior != null && this.hojasInteriorCodigos.includes(anterior.codigo))
                                this.solucionConstructiva.hojaInterior = anterior;

                            this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                            if (this.hojasInteriorCodigos.length <= 0) this.cargarAislantes();
                            resolve();
                        })
                        .finally(() => {
                            this.cargandoHojas = false;
                        });
                });
            },
            cargarAislantes() {
                return new Promise((resolve) => {
                    this.aislantes = [];
                    this.aislantesCodigos = [];
                    if (this.solucionConstructiva.tipoFachada == null) return;
                    if (this.hojasInteriorCodigos.length > 0 && this.solucionConstructiva.hojaInterior == null)
                        return;

                    let id = this.solucionConstructiva.id;
                    let url = `fachada/obra-nueva/solucion-constructiva/${id}/posible-aislante`;

                    let hojaInterior = this.solucionConstructiva.hojaInterior;
                    let params = {
                        tipoFachada: this.solucionConstructiva.tipoFachada.codigo,
                        hojaInterior: hojaInterior == null ? null : hojaInterior.codigo
                    };

                    let anterior = this.solucionConstructiva.aislante;
                    this.cargandoAislantes = true;
                    HttpHelper.get(url, params)
                        .then(data => {
                            this.aislantes = data;

                            data.forEach((type) => {
                                this.aislantesCodigos.push(type.codigo);
                            });
                            this.solucionConstructiva.aislante = null;
                            if (anterior != null && this.aislantesCodigos.includes(anterior.codigo))
                                this.solucionConstructiva.aislante = anterior;
                            this.cargarBarreraVapor();
                            resolve();
                        })
                        .finally(() => {
                            this.cargandoAislantes = false;
                        });
                });
            },
            cargarBarreraVapor() {
                return new Promise((resolve) => {
                    this.barreraVapor = [];
                    this.barreraVaporCodigos = [];
                    if (this.solucionConstructiva.tipoFachada == null) return;
                    if (this.solucionConstructiva.aislante == null) return;

                    let url = `fachada/obra-nueva/posible-barrera-vapor`;

                    let params = {
                        tipoFachada: this.solucionConstructiva.tipoFachada.codigo,
                        aislante: this.solucionConstructiva.aislante.codigo
                    };

                    let anterior = this.solucionConstructiva.barreraVapor;

                    this.cargandoBarreraVapor = true;
                    HttpHelper.get(url, params)
                        .then(data => {
                            this.barreraVapor = data;

                            data.forEach((type) => {
                                this.barreraVaporCodigos.push(type.codigo);
                            });

                            this.solucionConstructiva.barreraVapor = null;
                            if (anterior != null && this.barreraVaporCodigos.includes(anterior.codigo))
                                this.solucionConstructiva.barreraVapor = anterior;

                            this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                            resolve();
                        })
                        .finally(() => {
                            this.cargandoBarreraVapor = false;
                        });
                });
            },
            cambiaFachada: function (item) {
                if (!this.fachadasCodigos.includes(item.codigo)) {
                    this.solucionConstructiva.tipoFachada = null;
                    return;
                }
                this.cargarHojaInterior();
            },
            cambiaHojaInterior: function (item) {
                if (!this.hojasInteriorCodigos.includes(item.codigo)) {
                    this.solucionConstructiva.hojaInterior = null;
                    return;
                }
                this.cargarAislantes();
            },
            cambiaAislante: function (item) {
                if (!this.aislantesCodigos.includes(item.codigo)) {
                    this.solucionConstructiva.aislante = null;
                    return;
                }
                this.cargarBarreraVapor();
            },
            cambiaBarreraVapor: function (item) {
                if (!this.barreraVaporCodigos.includes(item.codigo)) {
                    this.solucionConstructiva.barreraVapor = null;
                }
            },
            solucionConstructivaEsCorrecta(solucionConstructiva) {
                if (solucionConstructiva.tipoFachada == null ||
                    !this.fachadasCodigos.includes(solucionConstructiva.tipoFachada.codigo)) return false;

                if (this.hojasInteriorCodigos.length > 0) {
                    if (solucionConstructiva.hojaInterior == null ||
                        !this.hojasInteriorCodigos.includes(solucionConstructiva.hojaInterior.codigo)) return false;
                } else {
                    if (solucionConstructiva.hojaInterior != null) return false;
                }


                if (solucionConstructiva.aislante == null ||
                    !this.aislantesCodigos.includes(solucionConstructiva.aislante.codigo)) return false;

                if (this.barreraVaporCodigos.length > 0) {
                    if (solucionConstructiva.barreraVapor == null ||
                        !this.barreraVaporCodigos.includes(solucionConstructiva.barreraVapor.codigo)) return false;
                } else {
                    if (solucionConstructiva.barreraVapor != null) return false;
                }

                return true;
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "tipo_fachada": "Tipo de fachada",
    "hoja_interior": "Hoja interior",
    "aislante": "Aislante",
    "barrera_vapor": "Barrera vapor",
    "no_aplica": "No aplica",
    "tipo_fachada_antes": "Se debe seleccionar el tipo de fachada antes",
    "tipo_fachada_hoja_antes": "Se debe seleccionar el tipo de fachada y hoja interior antes",
    "hoja_antes": "Se debe seleccionar el tipo hoja interior antes",
    "tipo_fachada_aislante_antes": "Se debe seleccionar el tipo de fachada y aislante antes",
    "aislante_antes": "Se debe seleccionar el aislante antes"
    }
    }
</i18n>
<!--@formatter:on-->